export default {
  getVariables(state) {
    return state.variables
  },
  getCurrentModel(state) {
    return state.currentModel
  },
}
